(function autoCloseDetails() {
  const localizationSelector = 'details[data-hallowvia-localization-selector]';

  function closeDetails(element, restoreFocus = false) {
    if (!(element instanceof HTMLDetailsElement) || !element.open) return;

    element.open = false;
    const summary = element.querySelector(':scope > summary');
    summary?.setAttribute('aria-expanded', 'false');
    if (restoreFocus && summary instanceof HTMLElement) summary.focus();
  }

  function updatePanelAvailableHeight(element) {
    if (!(element instanceof HTMLDetailsElement) || !element.open) return;

    const availableHeight = Math.max(96, Math.floor(element.getBoundingClientRect().bottom - 8));
    element.style.setProperty('--hallowvia-localization-panel-available-height', `${availableHeight}px`);
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    const clickedSummary = event.target.closest(`${localizationSelector} > summary`);
    const clickedOption = event.target.closest(
      `${localizationSelector} button[type="submit"][name="language_code"], ${localizationSelector} button[type="submit"][name="country_code"]`
    );

    if (clickedSummary) {
      const selectedDetails = clickedSummary.closest(localizationSelector);

      for (const detailsElement of document.querySelectorAll(`${localizationSelector}[open]`)) {
        if (detailsElement !== selectedDetails) closeDetails(detailsElement);
      }
    }

    if (clickedOption) closeDetails(clickedOption.closest(localizationSelector));

    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) closeDetails(detailsElement);
  });

  document.addEventListener(
    'toggle',
    function (event) {
      const detailsElement = event.target;
      if (!(detailsElement instanceof HTMLDetailsElement) || !detailsElement.matches(localizationSelector)) return;

      const summary = detailsElement.querySelector(':scope > summary');
      summary?.setAttribute('aria-expanded', detailsElement.open ? 'true' : 'false');
      if (detailsElement.open) updatePanelAvailableHeight(detailsElement);
    },
    true
  );

  window.addEventListener('resize', function () {
    for (const detailsElement of document.querySelectorAll(`${localizationSelector}[open]`)) {
      updatePanelAvailableHeight(detailsElement);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    const openSelectors = [...document.querySelectorAll(`${localizationSelector}[open]`)];
    if (openSelectors.length === 0) return;

    event.stopPropagation();
    for (const detailsElement of openSelectors) closeDetails(detailsElement, true);
  });
})();
